var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcContent',{attrs:{"app-name":"tasks"}},[_c('AppNavigation',{nativeOn:{"click":function($event){return _vm.closeAppSidebar($event)}}}),_vm._v(" "),_c('NcAppContent',{nativeOn:{"click":function($event){return _vm.closeAppSidebar($event)}}},[_c('RouterView')],1),_vm._v(" "),_c('RouterView',{attrs:{"name":"AppSidebar"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }